import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import type { ThunkApiType } from '@/store';

import { uiSlice } from '@/domain/ui/redux';
import { userSlice } from '@/domain/user/redux';
import { service } from '@/share';

export const forgotPassword = createAsyncThunk<
  void,
  string,
  ThunkApiType
>(
  'auth/forgotPassword',
  async (username, thunkApi) => {
    const { status, msg } = await service.user.forgotPassword(username);
    if (status === 'ok') {
      thunkApi.dispatch(uiSlice.actions.setMessage({ key: 'info', content: msg }));
      thunkApi.dispatch(userSlice.actions.setUser({
        name: username,
      }));
      thunkApi.dispatch(userSlice.actions.setMode('forgotpasswordsubmit'));
    } else {
      thunkApi.dispatch(uiSlice.actions.setMessage({ key: 'error', content: msg }));
    }
  },
);

export const forgotPasswordSubmit = createAsyncThunk<
  void,
  {
    /** ユーザー名 */
    username: string;
    /** パスワード */
    password: string;
    /** パスワード(確認) */
    passwordConfirm: string;
    /** コード */
    code: string;
  },
  ThunkApiType
>(
  'auth/forgotPasswordSubmit',
  async (input, thunkApi) => {
    const { status, msg } = await service.user.forgotPasswordSubmit(
      input.username,
      input.code,
      input.password,
    );
    if (status === 'ok') {
      thunkApi.dispatch(uiSlice.actions.setMessage({ key: 'info', content: msg }));
      thunkApi.dispatch(userSlice.actions.setMode('signin'));
    } else {
      thunkApi.dispatch(uiSlice.actions.setMessage({ key: 'error', content: msg }));
      thunkApi.dispatch(userSlice.actions.setMode('forgotpassword'));
    }
  },
);
